export enum StreamState {
	live = 'live',
	offline = 'offline',
}

export type StreamStateChange = {
	/** id is a BIGINT */
	id: number;
	stream_id: string;
	current_state: StreamState;
	session_uuid: string;
	timestamp: Date;
	metadata: Record<string, string>;
}

export type LiveStateChangePayload = {
	sessionUuid: string;
	state: StreamState;
	language: string;
	playbackUrl: PlaybackUrl;
	playbackPath: PlaybackPath;
	startAt?: number;
	endAt?: number;
}

export type PlaybackPath = `/${string}.m3u8`;
export type PlaybackUrl = `https://${string}${PlaybackPath}`;

export type LiveStateGetResponseItem = {
	playbackUrl: PlaybackPath;
	data: {
		state: StreamState;
		timestamp: number;
	};
}

export type LiveStateGetResponse = LiveStateGetResponseItem[];

export type LiveEventStateGetResponseItem = {
	sessionUuid: string;
	state: StreamState;
}

export type LiveEventStateGetResponse = LiveEventStateGetResponseItem[];

export type LiveStateEntry = {
	state: StreamState;
	liveAt: number;
	endAt?: number;
}

export type LiveState = {
	[key: PlaybackPath]: LiveStateEntry;
};